import React from 'react';

import './AutomaticTransactionTypes.scss';

import {
  IRA_AUTO_MAX,
  RECURRING_BUY,
  RECURRING_EXCHANGE,
  RECURRING_SELL,
  RMD,
} from '../../../settings/settings';
import AppTitle from '../../Shared/AppTitle/AppTitle';
import If from '../../Shared/If/If';
import TransactionGroup from '../TransactionGroup/TransactionGroup';
import TRP from '../../Shared/TRP/TRP';
import { useSelector } from 'react-redux';
import { getUserOwnedIRAs } from '../../../redux/modules/funds/UserFunds/userFunds.selectors';
import { getUserHasAutoMaxPOAs } from '../../../redux/modules/automaticInvestments/automaticInvestments.selectors';
import config from '../../../config/config';
import { appendBasePath } from '../../../utils/nav.utils';
import useAutomaxRetirement from '../../IRAAutoMax/useAutomaxRetirement';
import IRAAutoMaxMboxCallToAction from '../../IRAAutoMax/IRAAutoMaxMboxCallToAction';

const AutomaticTransactionTypes = ({
  isIFrame,
  isSalesforceRep,
  customerWebViewEnabled,
  recurringRedemptions,
  recurringPurchases,
  autoExchanges,
  ownsIRAs,
  autoInvestments,
  appData,
  getHasCollegeOnly,
  RMDEligible,
  systematicActivityRMDs,
  hasAutoMaxIRAs,
}) => {
  console.log(appData, 'asdads', autoInvestments);
  const userOwnedIRAs = useSelector(getUserOwnedIRAs);
  const userHasPOAs = useSelector(getUserHasAutoMaxPOAs);
  const userAlreadyHasAutoMax = hasAutoMaxIRAs.ownedFunds.length > 0;
  const { offer } = useAutomaxRetirement();
  return (
    <div className="automatic-transaction-types-container">
      <If test={!(isIFrame || (!customerWebViewEnabled && isSalesforceRep))}>
        <AppTitle
          title={
            getHasCollegeOnly
              ? 'Automatic Monthly Contributions (AMC)'
              : 'Automatic Transactions'
          }
        />
      </If>
      {offer && (
        <div>
          <IRAAutoMaxMboxCallToAction
            messageName={offer.messageName}
            messageText={offer.messageText}
          />
        </div>
      )}
      <If
        test={
          !autoInvestments.autoUpdateReload &&
          (appData.hasFailed || appData.isLoaded)
        }
      >
        <If test={RMDEligible}>
          <TransactionGroup
            title={'Auto-RMD'}
            subtitle={
              'Set up Required Minimum Distribution (RMD) from eligible IRA investments every year.'
            }
            buttonText={'Manage Auto-RMD'}
            funds={systematicActivityRMDs}
            link={`${config.url}/usis/rmd-tool`}
            type={RMD}
          />
        </If>
        <TransactionGroup
          title={
            getHasCollegeOnly
              ? 'Automatic Monthly Contributions'
              : 'Automatic Buy'
          }
          subtitle={
            getHasCollegeOnly ? (
              'Set up recurring contributions into your 529 accounts'
            ) : (
              <div>
                Set up recurring purchases to move assets into your <TRP />{' '}
                accounts
              </div>
            )
          }
          buttonText={getHasCollegeOnly ? 'Add an AMC' : 'Add an Automatic Buy'}
          link={`${config.url}${appendBasePath('/automatic/buy')}`}
          type={RECURRING_BUY}
          funds={Array.isArray(recurringPurchases) ? recurringPurchases : []}
        />
        <If test={!getHasCollegeOnly}>
          <TransactionGroup
            title="Automatic Sell"
            subtitle={
              <div>
                Set up recurring withdrawals that sell assets from your <TRP />{' '}
                accounts.
              </div>
            }
            buttonText="Add an Automatic Sell"
            link={`${config.url}${appendBasePath('/automatic/sell')}`}
            type={RECURRING_SELL}
            funds={
              Array.isArray(recurringRedemptions) ? recurringRedemptions : []
            }
          />
          <TransactionGroup
            title="Automatic Exchange"
            subtitle={
              <div>
                Set up recurring transactions to move assets from one eligible{' '}
                <TRP /> account to another.
              </div>
            }
            buttonText="Add an Automatic Exchange"
            link={`${config.url}${appendBasePath('/automatic/exchange')}`}
            type={RECURRING_EXCHANGE}
            funds={Array.isArray(autoExchanges) ? autoExchanges : []}
          />
          {userAlreadyHasAutoMax && (userOwnedIRAs || userHasPOAs) && (
            <TransactionGroup
              title="IRA AutoMax"
              subtitle="Set up a recurring buy that will automatically maximize your IRA contributions each year."
              link={`${config.url}${appendBasePath('/automatic/ira-automax')}`}
              buttonText={'Activate IRA AutoMax'}
              showButton={!userAlreadyHasAutoMax && userOwnedIRAs}
              type={IRA_AUTO_MAX}
              ownsIRAs={ownsIRAs}
              funds={[]}
            />
          )}
        </If>
      </If>
    </div>
  );
};

export default AutomaticTransactionTypes;
